import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import { LookupCursadas } from '../Cursadas/LookupCursadas';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { InscripcionExamenErrorMessage } from '../InscripcionExamen/InscripcionExamenErrorMessage';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddInscripcionCursada extends Component {
  static displayName = AddInscripcionCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      showCursada: false,
      alumno: { codigo: '', descripcion: '' },
      carreraCursada: -1,
      tagData: [{ id: '', text: '', materiaCarreraCod3: '' }],
      ignorarCorrelatividad: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWInscripcionCursada');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleShowCursadaLookup = () => {
    if (!this.state.loading && this.state.carreraCursada !== -1) {
      this.setState({ showCursada: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupAnios: false,
      carreraCursada: Number(carreraProperties[3]),
      alumno: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2],
      },
      tagData: [{ id: '', text: '', materiaCarreraCod3: '' }],
    });
  };

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const cursadaCod = carreraProperties[0];
    const alreadySelected = this.state.tagData.some((tag) => tag.id === cursadaCod);
    if (alreadySelected) {
      this.setState({ showCursada: false });
      return;
    }

    const tag = {
      id: cursadaCod,
      text: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[4].trim(),
      materiaCarreraCod3: carreraProperties[5].trim(),
    };

    this.clearFeedback();
    this.setState({
      showCursada: false,
      tagData: [...this.state.tagData, tag],
    });
  };

  handleDelete = (id) => {
    this.clearFeedback();
    this.setState({
      tagData: this.state.tagData.filter((tag) => tag.id !== id),
    });
  };

  handleCheckBox = (e) => {
    this.clearFeedback();
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  isFormValid() {
    const tags = this.state.tagData.slice(1);
    return this.state.alumno.descripcion.length > 1 && tags.length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveStudent();
  }

  renderCursadaTags() {
    const tagData = this.state.tagData.slice(1);
    if (tagData.length === 0) {
      return <p className="md-form-page__empty-hint">Ninguna cursada seleccionada</p>;
    }
    return (
      <ul className="md-form-page__tags md-form-page__tags--stack">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-form-page__tag md-form-page__tag--stacked md-form-page__tag--inline">
            <span className="md-form-page__tag-label">{tag.text}</span>
            <button
              type="button"
              className="md-form-page__tag-remove"
              onClick={() => this.handleDelete(tag.id)}
              disabled={this.state.loading}
              aria-label={'Quitar ' + tag.text}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    );
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const cursadas = this.state.tagData.slice(1).map((tag) => ({
      Cursada: parseInt(tag.id, 10),
      MateriaCarreraCod3: tag.materiaCarreraCod3,
    }));

    const { data } = await constantClass.apiFetch('api/ic/multiple', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoxCarreraCod: this.state.alumno.codigo,
        IgnorarCorrelatividad: this.state.ignorarCorrelatividad,
        Cursadas: cursadas,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron guardar las inscripciones. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-ic" />;
    }

    const {
      loading,
      errorMessage,
      alumno,
      carreraCursada,
      showLookupAnios,
      showCursada,
      ignorarCorrelatividad,
    } = this.state;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ic">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Inscripción a Cursada</h1>
        <p className="md-form-page__subtitle">
          Seleccione el alumno y una o más cursadas. Cada materia se registrará como una inscripción independiente.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <InscripcionExamenErrorMessage message={errorMessage} /> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando inscripciones, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowAniosLookup}
                disabled={loading}
              >
                Seleccione el Alumno
              </button>
              {showLookupAnios ? (
                <LookupAlumnoCarrera
                  selectItem={this.handleSelectAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.descripcion}
                placeholder="Alumno seleccionado"
                readOnly
                disabled
                aria-label="Alumno seleccionado"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Cursadas</span>
              {carreraCursada !== -1 ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCursadaLookup}
                  disabled={loading}
                >
                  Seleccione la Cursada
                </button>
              ) : (
                <p className="md-form-page__empty-hint">Seleccione el Alumno antes de elegir las Cursadas.</p>
              )}
              {showCursada ? (
                <LookupCursadas
                  carreraCod={carreraCursada}
                  selectItem={this.handleSelectCursadaItem}
                  hideLookup={this.handleHideLookup1}
                />
              ) : null}
              {this.renderCursadaTags()}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="ic-ignorar-correlatividad">
                <input
                  id="ic-ignorar-correlatividad"
                  type="checkbox"
                  checked={ignorarCorrelatividad}
                  onChange={this.handleCheckBox}
                  disabled={loading}
                />
                {' '}Ignorar verificación de correlatividad
              </label>
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
